import React from 'react';
import cn from 'classnames';
import SvgIcon from '../../SvgIcon';

const ImageUploaderCard = ({
  imgUrl,
  type,
  label,
  hasError,
  isLoading,
  onChange,
  onUpload,
  onRemove,
}) => {
  const renderEmptyImage = () => (
    <div
      className={cn('image-uploader-card-placeholder -no-text', hasError && '-error')}
      onClick={onUpload}
    >
      <label className="image-uploader-card-placeholder_upload">Upload image</label>
    </div>
  );

  const renderLoading = () => (
    <div className="image-uploader-card">
      <div className="image-uploader-card_image-wrapper -loading" />
    </div>
  );

  const renderImage = () => (
    <div className={cn('image-uploader-card', hasError && '-error')}>
      <div className="image-uploader-card_image-wrapper">
        <img src={imgUrl} />
        <button type="button" className="image-uploader-card_edit-photo" onClick={onChange}>
          <SvgIcon icon="icon-edit-button" />
        </button>
        <button type="button" className="image-uploader-card_remove-photo" onClick={onRemove}>
          <SvgIcon icon="icon-remove-button" />
        </button>
      </div>
    </div>
  );

  if (isLoading) {
    return renderLoading();
  } else if (imgUrl) {
    return renderImage();
  }
  return renderEmptyImage();
};

export default ImageUploaderCard;



// WEBPACK FOOTER //
// ./app/javascript/common/components/ImageUploader/ImageUploaderCard.js